import React, { useEffect, useState } from 'react';
import MinPromisePopup1 from './MinPromisePopup1';
import MinPromisePopup2 from './MinPromisePopup2';
import MinPromisePopup3 from './MinPromisePopup3';
import MinPromisePopup4 from './MinPromisePopup4';
import { Button, Dialog, useMediaQuery, useTheme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import {
  GUARDIAN_SETTINGS_ROUTE,
  PAYMENT_ROUTE,
  VERIFICATION_PAYMENT_SUCCESS_ROUTE,
} from '../../../../constants/routes.constants';
import { useAuth } from '../../../auth/Auth';

const MinPromisePopups = ({ showModal, setShowModal, popupNumber }) => {
  const { refreshUserState } = useAuth();
  const theme = useTheme();
  const history = useHistory();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showPopup1, setShowPopup1] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [showPopup4, setShowPopup4] = useState(false);
  const { type, from } = history?.location?.state;
  const newChild = history?.location?.state?.newChild
    ? JSON.parse(history?.location?.state?.newChild)
    : '';
  const childData = history?.location?.state?.childData
    ? JSON.parse(history?.location?.state?.childData)
    : '';

  useEffect(() => {
    if (popupNumber === 1) setShowPopup1(true);
    if (popupNumber === 2) setShowPopup2(true);
  }, [popupNumber]);

  const onClose = () => {
    setShowModal(false);
    setShowPopup1(false);
    setShowPopup2(false);
  };

  const handleRedirect = () => {
    if (type === 'invited') {
      if (newChild?.school_details?.pay_by === 'by_guardian') {
        history.push({
          pathname: `${PAYMENT_ROUTE}`,
          state: {
            dependent: JSON.stringify(newChild),
            type: 'activate',
          },
        });
      } else {
        history.replace({
          pathname: VERIFICATION_PAYMENT_SUCCESS_ROUTE,
          state: { isCamp: true, dependent: childData, from: 'verified' },
        });
      }
    } else {
      refreshUserState();
      history.push({
        pathname: `${PAYMENT_ROUTE}`,
        state: {
          dependent: JSON.stringify(newChild),
          type: newChild?.profile?.is_activated ? 'edit' : 'activate',
        },
      });
    }
  };

  const handleFirstPopupClose = () => {
    onClose();
  };

  const handleSecondPopupClose = () => {
    setShowPopup2(false);
    setShowPopup3(true);
  };

  const handleThirdPopupClose = () => {
    setShowPopup3(false);
    setShowPopup4(true);
  };

  const handleFourthPopupClose = () => {
    setShowPopup4(false);
    setShowModal(false);
    if (from === 'onboarding') {
      handleRedirect();
    } else {
      history.push(GUARDIAN_SETTINGS_ROUTE);
    }
  };

  return (
    <Dialog
      open={showModal}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: { borderRadius: '15px', padding: isMobile ? '8px' : '16px' },
      }}
    >
      {/* Close button */}
      {/* <Button
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          minWidth: '0',
          padding: '5px',
        }}
      >
        <Close style={{ color: '#321b6d' }} />
      </Button> */}
      {showPopup1 && <MinPromisePopup1 handleClose={handleFirstPopupClose} />}
      {showPopup2 && <MinPromisePopup2 handleClose={handleSecondPopupClose} />}
      {showPopup3 && <MinPromisePopup3 handleClose={handleThirdPopupClose} />}
      {showPopup4 && <MinPromisePopup4 handleClose={handleFourthPopupClose} />}
    </Dialog>
  );
};

export default MinPromisePopups;
